import React from 'react';
import ContextMenu, {Position} from 'devextreme-react/context-menu';
import List from 'devextreme-react/list';
// import {useLanguage} from '../../contexts/language';
import './language-panel.scss';
//import {useHistory} from 'react-router';
import { useDispatch, useSelector } from "react-redux";
import * as languageActions from '../../actions/languageActions';
//import CustomStore from "devextreme/data/custom_store";

export default function ({menuMode}) {
    //const history = useHistory();
    const dispatch = useDispatch();
    const language = useSelector(state => state.language);
    const languageList =  useSelector(state => state.languageList);
    //dispatch(languageActions.getList());
    


    function changeLang(lang) {

        dispatch(languageActions.changeLanguage(lang));
    }

    
    const menuItems =[];
    
    if(languageList != null && languageList.length >0 )    { 
        languageList.map(lang => {

            let imageName = ""; 
            if (lang.code === "tr") {
                imageName = 'assets/images/turkey-flag-icon-64.png';
            } else if (lang.code === "tm") {
                imageName = 'assets/images/turkmenistan-flag-icon-64.png';
            } else if (lang.code === "ru") {
                imageName = 'assets/images/russia-flag-icon-64.png';
            } else if (lang.code === "en") {
                imageName = 'assets/images/united-kingdom-flag-icon-64.png';
            } else if (lang.code === "ar") {
                imageName = 'assets/images/saudi-arabia-flag-icon-64.png';
            }
            

            let language1 =
            {
                text: lang.name,
                icon:imageName,// 'assets/images/turkmenistan-flag-icon-64.png',
                languageName:lang.name,
                onClick: ()=> changeLang(lang),
                name:lang.name,
                code:lang.code
            };
            menuItems.push(language1);
            
          }) 
               
    }

 
   

    return (
        <div className={'language-panel'}>
            <div className={'language-info'}>
                 {/* <div className={'image-container'}>
                   <div style= { {width:'32px', height:'32px',background: `url(${('languageImage')}) no-repeat center center`,}}/>
                </div>  */}
               <div className={'language-name'}>{language.name}</div>
            </div>

            {menuMode === 'context' && (
                <ContextMenu
                    items={menuItems}
                    target={'.language-button'}
                    showEvent={'dxclick'}
                    width={100}
                    cssClass={'user-menu'}
                >
                    <Position my={'top center'} at={'bottom center'}/>
                </ContextMenu>
            )}
            {menuMode === 'list' && (
                <List className={'dx-toolbar-menu-action'} items={menuItems}/>
            )}
        </div>
    );
}
